import React, { useEffect, useState } from 'react';
import { BillConceptos, BillConceptTax, FiscalpopImpuesto } from '../../../models/Factura';
import AutoComplete from '../../Forms/Autocomplete';
import Input from '../../Forms/Input';
import Button from '../../Forms/Button';
import { useLazyQuery } from '@apollo/react-hooks';
import { graphqlSchema } from '../../../services/graphql.schema';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { searchClaveUnidades, searchProductosServicios } from '../../../services/fiscalpopApi';
import { ConceptoCatalogo } from '../../../models/Catalogos';
import { clearGqlTypename } from '../../../utils/formatting';
import { ConceptoElementImpuesto } from './Factura.devolucion.impuesto';
import { EMPTY_CONCEPTO_DEVOLUCION } from './Factura.devolucion.empty';

export function ConceptoElementDevolucion({ authToken, removeConcepto, validRequested, conceptoIndex, concepto, impuestosList, handleConceptoUpdate, hideCantidad, descripcionAsInput }: { authToken: string; validRequested: boolean; conceptoIndex: number, concepto: BillConceptos, impuestosList: FiscalpopImpuesto[], removeConcepto?: (i: number) => () => void, handleConceptoUpdate: (i: number) => (update: BillConceptos) => void, hideCantidad?: boolean, descripcionAsInput?: boolean }) {
    const [isLoading, setIsLoading] = useState(false);
    const [prodServSubject] = useState(new Subject<string>());
    const [unidadSubject] = useState(new Subject<string>());
    const [unidadOptions, setUnidadOptions] = useState<{ label: string; value: string }[]>([])
    const [claveOptions, setClaveOptions] = useState<{ label: string; value: string }[]>([])

    const [conceptoOptions, setConceptoOptions] = useState<ConceptoCatalogo[]>([]);
    const [searchByName] = useState(new Subject<string>());

    const [getByName] = useLazyQuery(graphqlSchema.PROFILE.CATALOGOS.getConceptoByName, {
        onCompleted: ({ getConceptoByName }: { getConceptoByName: ConceptoCatalogo[] }) => {
            setConceptoOptions(getConceptoByName);
            console.log('getConceptoByName: ', getConceptoByName);
        },
        onError: (e) => {
            console.error('Error fetching conceptos: ', e)
        }
    })

    useEffect(() => {
        const subs = searchByName.pipe(debounceTime(200)).subscribe(name => {
            getByName({
                variables: {
                    name
                }
            })
        })
        return () => {
            subs.unsubscribe();
        }
    }, [searchByName, getByName])


    useEffect(() => {
        const fetchUnidad = (defaultUnidadSat: string) => {
            setIsLoading(true);
            return searchClaveUnidades(authToken, {
                compare: defaultUnidadSat,
                clave: defaultUnidadSat
            }).then(response => {
                setIsLoading(false);
                setUnidadOptions(response.map((r: { clave: string, nombre: string }) => ({ label: `(${r.clave}) ${r.nombre}`, value: r.clave })))
            })
        }


        const fetchClaves = (defaultClaveSatProdServ: string) => {
            console.log('[SETUP - DEFAULTS] Fetching claves: ', defaultClaveSatProdServ);
            setIsLoading(true);
            return searchProductosServicios(authToken, {
                compare: defaultClaveSatProdServ,
                clave: defaultClaveSatProdServ
            }).then(response => {
                setIsLoading(false);
                setClaveOptions(response.map((r: { clave: string, descripcion?: string }) => ({ label: `(${r.clave}) ${r.descripcion}`, value: r.clave })))
            })
        }

        const prodSubs = prodServSubject.pipe(debounceTime(200)).subscribe(s => {
            fetchClaves(s || '');
        })
        const unidadSubs = unidadSubject.pipe(debounceTime(200)).subscribe(s => {
            fetchUnidad(s || '');
        })

        return () => {
            prodSubs.unsubscribe()
            unidadSubs.unsubscribe()
        }
    }, [prodServSubject, unidadSubject, authToken])

    const autoFillConceptoOption = (conceptoId: string) => {
        const conceptoToFill = conceptoOptions.find(c => c._id === conceptoId);
        console.log('conceptoToFill: ', conceptoToFill);
        handleConceptoUpdate(conceptoIndex)(Object.assign({ cantidad: 1 }, clearGqlTypename(conceptoToFill)));
    }

    const handleConceptoChange = (property: 'claveProdServ' | 'claveUnidad' | 'cantidad' | 'descripcion' | 'valorUnitario' | 'pedimento' | 'noIdentificacion' | 'descuento') => (value: any) => {
        const assigner: { [key: string]: any } = {};
        assigner[property] = value;
        const _concepto: BillConceptos = Object.assign({}, concepto, assigner);
        handleConceptoUpdate(conceptoIndex)(_concepto);
        if (property === 'claveProdServ') {
            prodServSubject.next(value);
        }
        if (property === 'claveUnidad') {
            unidadSubject.next(value);
        }
        if (property === 'descripcion') {
            searchByName.next(value);
        }
    }

    const handleAddNewTax = () => {
        concepto.impuestos.push(EMPTY_CONCEPTO_DEVOLUCION().impuestos[0]);
        console.log('Adding new tax: ', conceptoIndex, concepto);
        handleConceptoUpdate(conceptoIndex)(concepto);
    }

    const handleRemoveTax = (index: number) => (_: any) => {
        const _concepto = Object.assign({}, concepto);
        const taxes = _concepto.impuestos;
        console.log('Removing tax: ', conceptoIndex, concepto);
        if (taxes.length === 1) {
            _concepto.impuestos = EMPTY_CONCEPTO_DEVOLUCION().impuestos;
            handleConceptoUpdate(conceptoIndex)(_concepto);
        } else {
            _concepto.impuestos.splice(index, 1);
            handleConceptoUpdate(conceptoIndex)(_concepto);
        }
    }

    const handleImpuestoUpdate = (index: number) => (impuesto: BillConceptTax) => {
        const _concepto = Object.assign({}, concepto);
        _concepto.impuestos[index] = impuesto;
        handleConceptoUpdate(conceptoIndex)(_concepto);
    }

    const autoFillOptions = conceptoOptions.map(c => ({ label: c.descripcion, value: c._id }));
    return (

        <div className="concepto">
                {
                    removeConcepto ?
                        <Button setClass={'_eliminate'} secondary={true} handleClick={removeConcepto(conceptoIndex)}>
                            <div>
                                <span>Eliminar devolución # {conceptoIndex + 1}
                                </span>
                                <i className="material-icons delete">
                                    delete
                            </i>
                            </div>
                        </Button>

                        : ''
                }
            <div className="row two md-one">
                {
                    descripcionAsInput ?
                        <Input label="Descripción" hasError={validRequested && !concepto.descripcion} value={concepto.descripcion} placeholder="Nombre del producto" type="text" onChange={handleConceptoChange('descripcion')} />

                        :
                        <AutoComplete label="Descripción" hasError={validRequested && !concepto.descripcion} value={concepto.descripcion} placeholder="Nombre del producto" type="text" options={autoFillOptions} displayLabel={true} onChange={handleConceptoChange('descripcion')} onSelect={autoFillConceptoOption} />
                }
                <AutoComplete displayLabel={true} isLoading={isLoading} label="Clave producto o servicio" hasError={validRequested && !concepto.claveProdServ} value={concepto.claveProdServ} placeholder="Clave de producto o servicio" type="text" options={claveOptions} onChange={handleConceptoChange('claveProdServ')} onSelect={handleConceptoChange('claveProdServ')} />
            </div>
            {
                !!hideCantidad ?
                    <div className="row three lg-two md-gap-compressed">
                        <div className="select">
                            <AutoComplete displayLabel={true} isLoading={isLoading} label="Clave unidad" hasError={validRequested && !concepto.claveUnidad} value={concepto.claveUnidad} placeholder="Clave de unidad" type="text" options={unidadOptions} onChange={handleConceptoChange('claveUnidad')} onSelect={handleConceptoChange('claveUnidad')} />
                        </div>
                        <Input type="number" isCurrency={true} hasError={validRequested && !concepto.valorUnitario} label="Valor unitario (sin impuestos)" value={concepto.valorUnitario} placeholder="" onChange={handleConceptoChange('valorUnitario')} min={0.01} />
                    </div>
                    :
                    <div className="row four lg-three sm-two md-gap-compressed">
                        <div className="select">
                            <AutoComplete displayLabel={true} isLoading={isLoading} label="Clave unidad" hasError={validRequested && !concepto.claveUnidad} value={concepto.claveUnidad} placeholder="Clave de unidad" type="text" options={unidadOptions} onChange={handleConceptoChange('claveUnidad')} onSelect={handleConceptoChange('claveUnidad')} />
                        </div>
                        <Input type="number" label="Cantidad" hasError={validRequested && !concepto.cantidad} value={concepto.cantidad} placeholder="" onChange={handleConceptoChange('cantidad')} min={0.001} />
                        <Input type="number" isCurrency={true} hasError={validRequested && !concepto.valorUnitario} label="Valor unitario (sin impuestos)" value={concepto.valorUnitario} placeholder="" onChange={handleConceptoChange('valorUnitario')} min={0.01} />
                    </div>
            }
            {
                concepto.impuestos.map((impuesto, i) => {
                    return (
                        <ConceptoElementImpuesto i={i} key={i} impuesto={impuesto} impuestosList={impuestosList} handleImpuestoUpdate={handleImpuestoUpdate} handleAddNewTax={handleAddNewTax} handleRemoveTax={handleRemoveTax} />
                    )
                })
            }
        </div>
    )
}
